import React, { useState, use } from 'react';
import { FiHelpCircle } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { AiOutlineClockCircle } from "react-icons/ai";
import MockExamInterface from "./MockExamInterface"
import { Link } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuizCard = ({ quiz }) => {
  const navigate = useNavigate();

  // Once exam starts, directly show exam UI


  return (

    <div className="w-full bg-white border border-[#E0E0E0] rounded-[10px] p-4 md:p-5 mb-4 shadow-sm hover:shadow-md transition-all animate-in fade-in duration-500">
      <div className="flex flex-col md:flex-row justify-between items-stretch md:items-center gap-5">

        <div className="flex-1 text-left items-center">
          <div className="flex gap-2 mb-3">
            <span className="bg-[#21C11E] text-white  font-[500] px-3 md:px-4 py-2 rounded-[3px] uppercase tracking-wider text-[10px] md:text-[16px] ">
              FREE
            </span>
            {/* <span className="bg-[#D9D9D9] text-[#333] text-[9px] ] font-[500]  px-3 md:px-4 py-1 rounded-[4px] uppercase tracking-wider text-[10px] md:text-[16px]">
            {quiz.examType}
          </span> */}
          </div>
          <h3 className="text-[18px] md:text-[20px] font-[500] text-[##333333] tracking-tight font-inter mb-4 md:mb-5 leading-tight">
            {quiz.title}: {quiz.exam}
          </h3>
          <div className="flex flex-wrap items-center gap-y-3 gap-x-5 md:gap-8 text-[#000000] font-[400] text-[13px] md:text-[16px] font-inter">
            <div className="flex items-center gap-2">
              <FiHelpCircle className="text-[16px] md:text-[14px] text-[#0F1729]" />
              <span>{quiz.totalQuestions} Questions</span>
            </div>
            <div className="flex items-center gap-2">
              <IoDocumentTextOutline className="text-[16px] md:text-[14px] text-[#0F1729]" />
              <span>{quiz.marks} Marks</span>
            </div>
            <div className="flex items-center gap-2">
              <AiOutlineClockCircle className="text-[16px] md:text-[14px] text-[#0F1729]" />
              <span>{quiz.durationMinutes} mins</span>
            </div>
          </div>
        </div>
        <button onClick={() => navigate(`/quiz/${quiz?._id}`)} className="w-full md:w-auto bg-[#4096F6] hover:bg-[#2563EB] text-white font-[500] py-3 md:py tracking-tight-3 w-[203px] px-8 md:px-12 rounded-[8px] transition-all shrink-0 text-[14px] md:text-[16px] shadow-sm active:scale-95 cursor-pointer">
          Start Now
        </button>

      </div>
    </div>
  );
}

export default QuizCard;